// client.ts
import { createClient } from '@sanity/client';

export default createClient({
  projectId: '756nuwp7', // you can find this in sanity.json
  dataset: 'staging', // or the name you chose in step 1
  useCdn: false, // `false` if you want to ensure fresh data : should be conditional based on prod / staging
});
